import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { NgxSpinnerService } from "ngx-spinner";
import { UtilService } from "src/app/shared/helper/util.service";
import { HomePageService } from "src/app/shared/services/homepage.service";
import { AnalyticsService } from "../../analytics/analytics.service";
import { DashboardService } from "../../analytics/dashboard-details/dashboard.service";
import _ from "lodash";
import { ManageRequestsService } from "../../manage-requests/manage-requests.service";
import { MatDialog } from "@angular/material/dialog";
import { RequestAccessDialogComponent } from "src/app/shared/request-access-dialog/request-access-dialog.component";

@Component({
    selector: "app-app-details",
    templateUrl: "./app-details.component.html",
    styleUrls: ["./app-details.component.scss"],
    standalone: false
})
export class AppDetailsComponent implements OnInit {
  module: any;
  imageSrc: string;
  moduleByteMap: any;
  modules: any[] = [];

  //
  product: any;
  userId: any = "";
  successMessage: any;
  isUserLoggedIn: boolean;
  subscriptionMsg =
    "Please contact DMINT Administrator to get subscription of the same";
  errMsg: any;
  showErrorMessageWithPopup: boolean;
  closeSign: string;
  subscriptionDetails: any[] = [];
  analyticsModuleId: any;
  insightsModule: any;
  insightsData: any;
  headerId: any = 4;
  insightsModuleRecords: any[] = [];
  searchText: any = "";
  currentPage = 1;
  sortBy = "created_date";
  sortType = "desc";
  getinsightsModules: any[] = [];
  allInsightsModulesHeaders: any;
  allProdcuts: any[];
  dashboard: any;
  stepOneDetails: any;
  companyId: any;

  constructor(
    public route: ActivatedRoute,
    public dashboardService: DashboardService,
    public analyticService: AnalyticsService,
    public spinnerService: NgxSpinnerService,
    public utilService: UtilService,
    public homePageService: HomePageService,
    public router: Router,
    public auth: AuthService,
    public manageRequestService: ManageRequestsService,
    private dialog: MatDialog,
  ) {}

  // shareLink() {
  //   const baseURL = window.location.href;
  //   if (navigator.clipboard) {
  //     navigator.clipboard.writeText(baseURL).then(() => {
  //       const msg = document.getElementById("copyMsg");
  //       msg.style.display = "block";
  //       setTimeout(() => msg.style.display = "none", 2000);
  //     }).catch(err => {
  //       console.error('Failed to copy: ', err);
  //     });
  //   }
  // }

  // onSubscribe() {
  //   this.errMsg = this.subscriptionMsg;
  //   this.closeSign = 'OK';
  //   // this.showErrorMessageWithPopup = true;
  // }

  // toggleFavourite(module:any): void {
  //   module.favorite = !module.favorite;
  //   let reqBody = {
  //       // "userId": this.userId,
  //       "moduleId": module.id||module.moduleId,
  //       "isFavourite": module.favorite
  //   }
  //   // this.markUnmarkFavourite(reqBody);
  // }

  ngOnInit(): void {
    // Get the image map
    // this.utilService.moduleBytes.subscribe((mod) => {
    //   this.moduleByteMap = mod as Object;
    //   console.debug('[AppDetails] moduleByteMap updated:', this.moduleByteMap);
    //   this.setImageSrc();
    // });

    // // Get the userId and then fetch modules list from API
    // this.utilService.getUserId.subscribe((userId: any) => {
    //   if (userId) {
    //     this.homePageService.onHeader(userId).subscribe((res: any) => {
    //       console.debug('[AppDetails] homePageService.onHeader response:', res);
    //       if (res && res.message === 'OK') {
    //         this.modules = res.result.find((r: any) => r.headerName === 'Applications')?.modules || [];
    //         console.debug('[AppDetails] modules loaded:', this.modules);
    //         this.setModuleFromRoute();
    //       }
    //     });
    //   }
    // });

    // // Listen to route changes
    // this.route.paramMap.subscribe((params) => {
    //   console.debug('[AppDetails] Route paramMap changed:', params.get('id'));
    //   this.setModuleFromRoute();
    //   this.setImageSrc();
    // });

    this.userId =
      localStorage.getItem("userId") != "undefined" &&
      localStorage.getItem("userId") != undefined
        ? localStorage.getItem("userId")
        : "";
    this.isUserLoggedIn =
      localStorage.getItem("id") != "undefined" &&
      localStorage.getItem("id") != undefined
        ? true
        : false;
    this.analyticsModuleId = +this.route.snapshot.params["id"];
    this.getHeader();
    this.utilService.companyId.subscribe((res: any) => (this.companyId = res));

    this.utilService.moduleBytes.subscribe((mod) => {
      this.moduleByteMap = mod as Object;
    });
  }

  // setModuleFromRoute() {
  //   const id = this.route.snapshot.paramMap.get('id');
  //   console.debug('[AppDetails] setModuleFromRoute id:', id);
  //   if (id && this.modules.length) {
  //     this.module = this.modules.find((m: any) => m.id == id);
  //     console.debug('[AppDetails] module found:', this.module);
  //     this.setImageSrc();
  //   }
  // }

  // setImageSrc() {
  //   if (this.module && this.moduleByteMap) {
  //     const img = this.moduleByteMap[this.module.moduleName] || this.moduleByteMap['Tyre Pairing'];
  //     this.imageSrc = img ? `data:image/png;base64,${img}` : '';
  //     console.debug('[AppDetails] setImageSrc:', this.imageSrc);
  //   }
  // }

  getHeader() {
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.insightsModule = res;
      if (this.insightsModule.message === "OK") {
        this.insightsData = this.insightsModule.result;
        this.insightsModuleRecords = [...this.insightsData];
        this.getUpdatedAnalyticsData();
      }
    });
  }
  getUpdatedAnalyticsData(flag = false) {
    let userId = localStorage.getItem("userId");
    userId = userId == "undefined" ? null : userId;

    let payload: any = {
      userId: userId,
      headerId: 5,
      searchText: this.searchText,
      categoryIds: null,
      regionIds: null,
      businessLineIds: null,
      functionIds: null,
      productLineIds: null,
      sortBy: this.sortBy,
      sortType: this.sortType,
      limit: 500,
      page: this.currentPage,
    };
    this.analyticService
      .getAllAnalyticsModules(payload, "analytics")
      .subscribe({
        next: (res: any) => {
          this.spinnerService.hide();
          this.getinsightsModules = res?.result;
          for (let modulerecord of this.insightsModuleRecords) {
            if (modulerecord.headerName == "Applications") {
              this.allInsightsModulesHeaders = _.cloneDeep(
                modulerecord.modules,
              );
            }
          }
          if (this.getinsightsModules?.length > 0) {
            this.getinsightsModules.forEach((ele: any) => {
              let index = this.allInsightsModulesHeaders?.findIndex(
                (item: any) => item.id == ele.moduleId,
              );
              if (index > -1) {
                ele.subscription =
                  this.allInsightsModulesHeaders[index]["subscription"];
                ele.moduleLink =
                  this.allInsightsModulesHeaders[index]["moduleLink"];
              }
            });

            if (flag) {
              this.allProdcuts = [];
              this.allProdcuts = [
                ...this.allProdcuts,
                ...this.getinsightsModules,
              ];
              this.getinsightsModules = _.cloneDeep(this.allProdcuts);
            }
          } else {
            this.getinsightsModules = _.cloneDeep(this.allProdcuts);
          }
          this.subscriptionDetails = this.getinsightsModules;
          this.getModuleDetails();
        },
        error: (err) => {
          this.spinnerService.hide();
          this.utilService.SharingDataTextMessage.subscribe((res: any) => {
            this.errMsg = res;
          });
          this.showErrorMessageWithPopup = true;
          setTimeout(() => {
            this.showErrorMessageWithPopup = false;
            this.errMsg = "";
          }, 5000);
        },
      });
  }
  getModuleDetails() {
    let userId = localStorage.getItem("userId");
    userId = userId == "undefined" ? null : userId;
    let reqBody: { userId: any | null; moduleId: any } = {
      userId: userId,
      moduleId: this.analyticsModuleId,
    };
    this.analyticService
      .getAnalyticsDetailsById(reqBody)
      .subscribe((res: any) => {
        if (res && res.result) {
          let dashboardWithSubscription = {};
          let index = this.subscriptionDetails.findIndex(
            (x: any) => x.id || x.moduleId == this.analyticsModuleId,
          );
          if (index > -1) {
            dashboardWithSubscription = {
              ...res.result,
              newlyAdded: this.subscriptionDetails[index].newlyAdded,
              subscription: this.subscriptionDetails[index].subscription,
              isInternal: this.subscriptionDetails[index].isInternal,
              accessCompleted: this.subscriptionDetails[index].accessCompleted,
              favorite: this.subscriptionDetails[index].favorite,
              moduleLink: this.subscriptionDetails[index].moduleLink,
              tags: this.subscriptionDetails[index].tags,
            };
          }
          this.product = dashboardWithSubscription;
        }
      });
  }
  redirectToEmail() {
    let email = this.product?.moduleOwnerEmail;
    const mailtoLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}`;
    window.open(mailtoLink, "_blank");
  }
  onSubscribe() {
    this.errMsg = this.subscriptionMsg;
    this.closeSign = "OK";
    this.showErrorMessageWithPopup = true;
  }
  onSignIn() {
    this.utilService.onSignIn();
  }

  onCloseHandlerSub() {
    if (this.errMsg.includes("Session Expired")) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(["/login"], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    } else {
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }
  shareLink() {
    const baseURL = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(baseURL)
        .then(() => {
          const msg = document.getElementById("copyMsg");
          msg.style.display = "block";
          setTimeout(() => (msg.style.display = "none"), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  }
  onApplicationsApicall(moduleLink: any) {
    this.spinnerService.hide();
    window.open(`${moduleLink}`, "_blank");
  }

  onRequestAccessClick(module: any) {
    this.getStepOneDetails(module);
  }

  getStepOneDetails(module: any) {
    this.manageRequestService
      .getDataForSteps(module.moduleId)
      .subscribe((res: any) => {
        if (res) {
          this.stepOneDetails = res.result;
          this.callRequestPopup(module, this.stepOneDetails);
        }
      });
  }
  callRequestPopup(module: any, stepDetails: any) {
    const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
      width: "800px",
      maxWidth: "90vw",
      data: {
        module: module,
        stepDetails: stepDetails,
        title: `Request access to ${module.moduleName}`,
        panelClass: "request-access-dialog",
        disableClose: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const apiPayload = {
          submittedByUserId: this.userId,
          companyId: this.companyId,
          headerId: this.headerId,
          moduleId: module?.moduleId,
          isModuleAttached: result?.isModuleAttached,
          userGroups: result?.userGroups,
        };
        this.manageRequestService.createAccessRequest(apiPayload).subscribe({
          next: (response: any) => {
            if (response.code == 200) {
              this.successMessage = response?.result;
              setTimeout(() => {
                this.successMessage = "";
              }, 5000);
              this.getHeader();
            }
          },
          error: (error) => {
            this.errMsg = "Failed to submit access request. Please try again.";
            this.showErrorMessageWithPopup = true;
            setTimeout(() => {
              this.errMsg = "";
              this.showErrorMessageWithPopup = false;
            }, 5000);
          },
        });
      }
    });
  }

  onAccessPending() {
    this.errMsg = `Please contact <a 
      href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
      target='_blank' 
      class='admin-email-link'>
      DMINT Administrator
    </a> to get access for the same`;
    this.closeSign = "OK";
    this.showErrorMessageWithPopup = true;
  }
}
